import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from 'mobx-react-lite';
import { styled } from '@mui/material/styles';
import { Grid, Paper, Stack, Divider, } from '@mui/material';
import { useStore } from '@mcn-platform/models';
import { useLocation, useNavigate } from 'react-router-dom';
import PlaceHolder from '../../common/PlaceHolder';
import AssetImage from '../../common/asset/AssetImage';
import PanelTitle from '../../item/LandingPageTabs/PanelTitle';
import ItemInfo from '../../item/card/ItemInfo';
import ItemCallToAction from '../../item/card/enrollPrice/CallToAction';
import { configLandingPage } from '../../common/portalConfig';
import ItemInstructors from '../../item/card/ItemInstructors';
import { getProgramData } from '../../item/getData';
import ItemHeadline from '../../item/card/ItemHeadline';
// type ProgramSummaryType = {
//   program: IProgram;
//   settings?: any;
// };
const StyledDivider = styled(Divider)(() => ({
    borderColor: ('dividerSecondary'),
    borderBottomWidth: 1,
}));
const ProgramSummary = ({ programID, 
// eslint-disable-next-line @typescript-eslint/no-unused-vars
handleEnroll, settings, editData, }) => {
    // console.log(settings);
    // const [program, setProgram] = useState<IProgram | undefined>();
    const store = useStore();
    const navigate = useNavigate();
    const location = useLocation();
    const portal = store.currentPortal;
    if (editData && !programID) {
        return (_jsx(PlaceHolder, { placeHolderName: "Select program to see preview" }));
    }
    if (!programID) {
        return null;
    }
    const program = store.getOrLoad('program', programID);
    const progressLink = store.getProgressLink(programID);
    const { progress } = progressLink;
    // console.log('program:', program);
    const { showPrice, buttonLabel, action, instructorAction, } = configLandingPage(portal, program, progress, navigate, location, '.');
    if (!program) {
        return null;
    }
    // const handleStartProgram = async () => {
    //   const courseSection = await program.getCourseToStart();
    //   handleEnroll(courseSection.item.course);
    // };
    const { name, description, headline, programImage, price, sellPrice, } = program;
    console.log('program', {
        program,
        progress,
        settings,
    });
    return (_jsx(Paper, { elevation: 0, sx: {
            display: 'flex',
            flexDirection: 'column',
            p: 2,
            pb: 3,
            boxShadow: '0 0 18px 0 rgba(9, 32, 46, 0.2)',
        }, children: _jsxs(Grid, { container: true, children: [_jsxs(Grid, { item: true, container: true, xs: 12, md: 7, sx: { pr: 2.5 }, spacing: 2, order: { xs: 2, md: 0 }, children: [_jsxs(Grid, { item: true, xs: 12, children: [settings.showTitle && _jsx(PanelTitle, { title: name }), _jsxs(Stack, { spacing: 1, divider: _jsx(StyledDivider, {}), children: [settings.showProgramInfo && (_jsx(Stack, { direction: "row", sx: { mt: -2 }, justifyContent: "space-between", children: _jsx(ItemInfo, { item: program }) })), _jsx(Stack, { children: _jsx(ItemHeadline, { headline: settings.showProgramHeadline && headline, description: settings.showProgramDescription && description, size: "medium", isShowMore: settings.showProgramDescription }) })] }), _jsx(StyledDivider, { sx: { marginTop: '8px' } })] }), _jsxs(Grid, { item: true, xs: 12, sx: {
                                flexDirection: 'column',
                                display: 'flex',
                            }, children: [settings.showInstructor && program.instructors && (_jsx(ItemInstructors, { showAvatar: true, size: "large", instructors: program.instructors, instructorAction: instructorAction })), _jsx(ItemCallToAction, { showPrice: showPrice, showButton: true, price: price, sellPrice: sellPrice, action: action, buttonLabel: buttonLabel, isFlexGrow: true })] })] }), _jsx(Grid, { item: true, xs: 12, md: 5, order: { xs: 1, md: 0 }, children: settings.showProgramMedia && (_jsx(Paper, { elevation: 0, sx: {
                            // bgcolor: 'primary.main',
                            borderRadius: 0,
                        }, children: _jsx(AssetImage, { asset: programImage, customStyle: { width: '100%', objectFit: 'cover' }, size: "thumb400w" }) })) })] }) }));
};
/**
 * Initiates load of all dependent data.  Returns promise that will
 * resolve once loaded.
 * @param props same props used to render function
 */
ProgramSummary.getData = async ({ programID }, store) => {
    console.log('Adding item to preload', programID);
    if (!programID) {
        console.log('No item to load for ProgramSummary card');
        return 'ok';
    }
    await getProgramData(store, programID);
    // console.log('imageAsset', imageAsset);
    return 'ok';
};
ProgramSummary.defaultProps = {
    settings: {
        showTitle: true,
        showProgramInfo: true,
        showProgramMedia: true,
        showProgramHeadline: true,
        showProgramDescription: false,
        showDividers: true,
        showInstructor: true,
        showPrice: true,
    },
    editData: undefined,
};
ProgramSummary.meta = {
    group: 'design',
    name: 'Program Summary Card',
    description: 'Component displays the details of a program',
    props: [
        {
            key: 'programID',
            name: 'Program',
            type: 'program', // note this is a special type recognized by the system
            description: 'The program to display information about',
        },
        {
            key: 'settings.showTitle',
            name: 'Show Title',
            type: 'boolean',
            description: 'Show title',
        },
        {
            key: 'settings.showProgramInfo',
            name: 'Show Program Info',
            type: 'boolean',
            description: 'Show the Program info on the card',
        },
        {
            key: 'settings.showProgramMedia',
            name: 'Show Program Image / Video',
            type: 'boolean',
            description: 'Show the program structure',
        },
        {
            key: 'settings.showProgramHeadline',
            name: 'Show Program Headline',
            type: 'boolean',
            description: 'Show headline description',
        },
        {
            key: 'settings.showProgramDescription',
            name: 'Show Program Description',
            type: 'boolean',
            description: 'Show program description',
        },
        {
            key: 'settings.showInstructor',
            name: 'Show Instructor',
            type: 'boolean',
            description: 'Show the instructor field on the card',
        },
        {
            key: 'settings.showPrice',
            name: 'Show Price',
            type: 'boolean',
            description: 'Show the price field on the card',
        },
    ],
    defaultConfig: {
        type: 'component',
        component: 'ProgramSummary',
        props: {
            programID: '@programID',
            handleEnroll: '@enrollAction',
            settings: {
                showTitle: true,
                showProgramInfo: true,
                showProgramMedia: true,
                showProgramHeadline: true,
                showProgramDescription: true,
                showInstructor: true,
                showDividers: true,
                showPrice: true,
            },
        },
    },
};
export default observer(ProgramSummary);
//# sourceMappingURL=ProgramSummary.js.map